import { render, staticRenderFns } from "./liteForm.vue?vue&type=template&id=6c6bdf22&scoped=true"
import script from "./liteForm.vue?vue&type=script&lang=js"
export * from "./liteForm.vue?vue&type=script&lang=js"
import style0 from "./liteForm.vue?vue&type=style&index=0&id=6c6bdf22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6bdf22",
  null
  
)

export default component.exports